import type { FC, Ref } from "react";

import { Checkbox, type CheckboxProps } from "../../../components";

export type InputCheckboxProxyProps = Omit<
  CheckboxProps,
  "value" | "onChange"
> & {
  value?: boolean;
  onChange?: (value: boolean) => void;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLInputElement>;
};

export const InputCheckboxProxy: FC<InputCheckboxProxyProps> = ({
  value,
  ref,
  ...props
}) => <Checkbox checked={value} {...props} ref={ref} />;
